export default __webpack_public_path__ + "static/media/609.64e3dad9.png";